module.exports = __webpack_public_path__ + "static/media/certificate.ef356c08.svg";